import './bonus2x1.css';
import { useLeague } from '../../../../hooks';
import { Gift } from 'lucide-react';

export const Bonus2x1 = () => {
  const { bonus } = useLeague();

  return (
    <>
      {bonus?.is2x1 && (
        <div className="bonus">
          <div className="bonus-blur" />

          <div className="bonus-content">
            <Gift className="bonus-icon" stroke="#CAFB10" />

            <div className='bonus-description'>
              <h2 className="bonus-title">
                ¡Promoción Especial! Compra 1, Recibe 2
              </h2>

              <p className="bonus-text">
                Por cada tarjeta que compres, recibirás automáticamente una
                tarjeta de regalo adicional.
              </p>
              <span className="bonus-highlight">
                Ambas tarjetas deben usarse en esta misma temporada.
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const Reward2x1 = ({ quantity }: { quantity: number }) => {
  const { bonus } = useLeague();

  return (
    <>
      {/* Reward */}
      {bonus?.is2x1 && (
        <div className="purchase-reward">
          <div className="emoji">🎁</div>

          <div>
            <div className="reward-title">Recibirás:</div>

            <div className="reward-total">
              <span className="big">{quantity * 2}</span> tarjetas en total
            </div>

            <div className="reward-sub">
              {quantity}{' '}
              {quantity === 1 ? 'tarjeta comprada' : 'tarjetas compradas'} +{' '}
              {quantity} {quantity === 1 ? 'tarjeta regalo' : 'tarjetas regalo'}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
